export const secciones = {
  '1': 'NPS',
  '2': 'Verklaringen',
  '3': 'Controle vragen',
  '4': 'Demografie',
  '5': 'Open vragen',
  '6': '4Alle praktijken',
  '7': 'Bijkomende vragen',
  '8': 'NOM035-verklaringen',
}
export const preguntas = {
  // '1': 'Enkele keuzevraag',
  '1': 'Meerkeuzevraag (keuzerondje)',
  '2': 'Open vraag',
  '3': 'Uitspraak',
  '4': 'Meerkeuzevraag (keuzerondje)',
  '5': '4 Alle praktijk',
  '6': 'Meerkeuzevraag (Check-knop)',
  '7': 'NOM035-verklaring',
  '8': 'Audio',
}
export const abiertas = {
  '1': 'Open tekst',
  '2': 'Numerieke tekst',
}
export const preguntasEspeciales = {
  '1': 'Normale vraag',
  '2': 'Speciale vraag',
}
